<template lang="pug">
  .support-review
    //support-avatar
    .main-grid
      h1 {{$t('title')}}
      template(v-if="!isSearching")
        .avatar-wrapper
          support-avatar(width="120" height="120" :gender="member.gender")
        h3.name {{$t(memberName)}}
        h3.occupation {{$t(member.duty)}}
        .like-buttons-wrapper
          div
            .like-btns.like-btn(@click.prevent="like")
              inline-svg(:src="require('./like.svg')" width="21px" height="20px")
          div
            .like-btns.dislike-btn(@click.prevent="dislike")
              inline-svg(:src="require('./like.svg')" width="21px" height="20px")
      template(v-if="isSearching")
        div.loading-wrapper
          circle-loader(size="5rem") {{$t('Загрузка данных...')}}
      template(v-if="model.errors.has()")
        div.positive-error
          error-message-block(:errors="model.errors" attribute="*|id")

    modal(:name="modalName" :adaptive="true" width="600px" height="auto" :clickToClose="false").review-form-modal
      .review-form-inner
        a.close(@click.prevent="closeModal" v-if="closeAvail")
          inline-svg(:src="require('./close.svg')" width="21" height="21")
        h1 {{$t('Расскажите подробнее, что вам не понравилось')}}:
        div.my-form
          guest-form-group(:label-text="$t('Ваш логин')" :required="true" :has-error="model.errors.has('username')" :error-message="model.errors.getMessage('username')")
            input.form-control(type='text' name="username" :disabled="formDisabled"  v-model="model.values.username" :placeholder="$t('Логин или email')" )
          guest-form-group(:label-text="$t('Контактные данные')" :required="true" :has-error="model.errors.has('contacts')" :error-message="model.errors.getMessage('contacts')")
            input.form-control(type='text' name="contacts"  :disabled="formDisabled" v-model="model.values.contacts" :placeholder="$t('Контактные данные, с которых вы обращались')" )
          guest-form-group(:label-text="$t('Где происходило общение')" :required="true" :has-error="model.errors.has('system')" :error-message="model.errors.getMessage('system')")
            dropdown-key-value(v-model="model.values.system" name="system" :disabled="formDisabled" :placeholder="$t('Выберите мессенджер')" :options="systemOptions")
          guest-form-group(:label-text="$t('Причина')" :required="true" :has-error="model.errors.has('reason')" :error-message="model.errors.getMessage('reason')")
            textarea.form-control(rows="5" v-model="model.values.reason" :disabled="formDisabled" :placeholder="$t('Опишите вашу проблему')" )
          div.form-buttons
            button.btn.btn-success(type="button" @click.prevent="onClickSubmit" :disabled="formDisabled")
              template(v-if="model.submitStatus.isLoading") {{$t('Отправляется...')}}
              template(v-else) {{$t('Отправить')}}

    modal(:name="successModalName" :adaptive="true" width="500px" height="auto" :clickToClose="false").success-modal
      .success-modal-inner
        a.close(href="/" alt="")
          inline-svg(:src="require('./close.svg')" width="21" height="21")

        .success-logo
          inline-svg(:src="require('./success.svg')" width="36" height="36")
        h1 {{$t('success.title')}}
        .success-text {{$t(model.values.rate > 0 ? 'success.text_positive' : 'success.text')}}
        .buttons
          a(href="/" alt="").btn.btn-success {{$t('success.closelabel')}}
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import SupportAvatar from "@/views/pages/support/SupportAvatar.vue";
import {GenderEnum, SupportReviewModel} from "@/views/pages/support/support-review";
import InlineSvg from 'vue-inline-svg';

import VueJSModal from "vue-js-modal";
import GuestFormGroup from "@/components/forms/guest/GuestFormGroup.vue";
import DropdownKeyValue from '@/components/forms/dropdown/DropdownKeyValue.vue';
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import CircleLoader from "@/components/loaders/CircleLoader.vue";

Vue.use(VueJSModal);

@Component({
  name: "SupportReview",
  components: {
    CircleLoader,
    ErrorMessageBlock, DropdownKeyValue, GuestFormGroup, SupportAvatar, InlineSvg}
})
export default class SupportReview extends Vue {
  @Prop({required: true})
  reqid: string

  model = new SupportReviewModel();

  get isSearching() {
    return this.model.checkStatus.isLoading;
  }

  finished = false

  defaultMember = {
    name: 'Василий Алибабаевич',
    nameEn: 'Vasily Alibabayevich',
    gender: 'male',
    duty: 'Специалист службы поддержки клиентов',
  }

  tokenMember = null

  get member() {
    return this.tokenMember ? this.tokenMember : this.defaultMember;
  }

  get memberName() {
    return this.$i18n.locale === 'ru' ? this.member.name : this.member.nameEn;
  }

  mounted() {
    this.model.checkId(this.reqid).then((data) => {
      this.tokenMember = Object.assign(data);
      if (data.rated) {
        this.showFinalThankYou(true);
        this.finished = true;
      }
    }).catch((err) => {
      //window.location.replace('/');
      this.showFinalThankYou(true);
      this.finished = true;
    })
  }

  get formDisabled() {
    return this.model.submitStatus.isLoading;
  }

  get closeAvail() {
    return !this.model.submitStatus.isLoading;
  }

  closeModal() {
    this.$modal.hide(this.modalName);
  }

  closeSuccessModal() {
    this.$modal.hide(this.successModalName);
  }

  get modalName() {
    return 'review-modal';
  }

  get successModalName() {
    return 'review-success-modal';
  }

  get systemOptions() {
    const result = {};

    for (const [key, value] of Object.entries(this.model.systemOptions)) {
      result[key] = this.$t(value)
    }

    return result;
  }

  showFinalThankYou(redirect = false) {
    this.$modal.show(this.successModalName);
    if (redirect)
      setTimeout(() => {
        window.location.replace('/')
      }, 3000);
  }

  like() {
    this.model.values.id = this.reqid;
    this.model.values.rate = 5;
    this.onClickSubmitPositive();
  }



  dislike() {
    this.model.errors.clear();
    this.model.values.id = this.reqid;
    this.model.values.rate = -1;
    this.$modal.show(this.modalName);
  }

  onClickSubmit() {
    return this.model.sendReview().then(() => {
      this.$modal.hide(this.modalName);
      this.showFinalThankYou();
    });
  }

  onClickSubmitPositive() {
    this.model.values.rate = 5;
    return this.model.sendReview().then(() => {
      this.$modal.hide(this.modalName);
      this.showFinalThankYou();
    });
  }
}
</script>

<style scoped lang="less">
.box-shadow (@string) {
  -webkit-box-shadow: @string;
  -moz-box-shadow:    @string;
  box-shadow:         @string;
}

.form-control-focus(@color: @input-border-focus) {
  @color-rgba: rgba(red(@color), green(@color), blue(@color), .6);
  &:focus {
    border-color: @color;
    outline: 0;
    .box-shadow(~"inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px @{color-rgba}");
  }
}

.form-control-error(@color: @input-border-focus) {
  @color-rgba: rgba(red(@color), green(@color), blue(@color), .6);

  &:not(:focus) {
    background-color: #FF000015;
  }


  //border-color: @color;
  //outline: 0;
  //.box-shadow(~"inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px @{color-rgba}");
}



.border-radius (@radius: 5px) {
  -webkit-border-radius: @radius;
  -moz-border-radius: @radius;
  border-radius: @radius;

  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}

@FFami1: Proxima Nova, Arial;

.support-review {
  background: #fff;
  padding: 91px;
  //box-shadow: 0px 2px 5px 0px rgb(27 138 168 / 9%);
  box-shadow: 0px 2px 5px 0px rgba(27, 138, 168, 0.09);
  .border-radius(6px);

  h1 {
    font-family: @FFami1;
    font-size: 42px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0;
    text-align: center;

    color: #333333;
    margin: 0;
  }

  .avatar-wrapper {
    margin-top: 29px;
    margin-bottom: 22px;
  }

  .main-grid {
    display: grid;
    grid-auto-flow: row;
    grid-template-rows: auto;
    grid-gap: 0;
    align-items: center;
    justify-items: center;

    h3 {
      padding: 0;
    }

    .positive-error {
      margin-top: 50px;
    }
  }

  .name {
    font-family: @FFami1;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 115%;
    margin: 0 0 10px 0;
  }

  .occupation {
    font-family: @FFami1;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 115%;
    /* or 16px */

    text-align: center;
    margin: 0;

    color: #8F8F8F;
  }
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.like-buttons-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-top: 25px;
}


.like-btns {
  width: 48px;
  height: 48px;
  left: 662px;
  top: 611px;

  /* White */

  background: #FFFFFF;
  box-shadow: 0px 6px 16px rgba(115, 117, 138, 0.25);
  display: grid;
  align-items: center;
  justify-content: center;
  .border-radius(50%);

  &.like-btn {
    svg {
      //margin-bottom: -3px;
    }
  }

  &.dislike-btn {
    svg {
      .rotateimg180();
      margin-bottom: -7px;
    }
  }

  &.like-btn, &.dislike-btn {
    cursor: pointer;
    transition: box-shadow .3s ease-in-out, background-color .4s ease-in-out;
    /*transition: background-color .8s linear;*/

    &:hover {
      background-color: #e4f8bb;
      box-shadow: 0px 3px 8px rgba(115, 117, 138, 0.25);
    }
  }
}

.review-form-modal {


  &::v-deep {
    .vm--modal {
      overflow: visible;
    }
    .dropdown-toggle {
      background-color: #f2f3f8;
    }
    .dropdown-menu {
      width: 100%;
    }

    .form-control {
      .form-control-focus(#71a7194d);
    }
    .has-error {
      .form-control {
        .form-control-error(rgba(255, 0, 0, 0.08));
      }
    }
  }



  textarea.form-control {
    -webkit-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08) inset;
    -moz-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08) inset;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08) inset;
    background-color: #f2f3f8;
    border: 1px solid #EEEEEE;
    padding: 9px 15px;
    .form-control-focus(#71a7194d);
  }

  .review-form-inner {
    padding: 50px;

    .close {
      position: absolute;
      right: 30px;
      top: 30px;
    }

    .form-buttons {
      align-items: center;
      justify-content: center;
      margin-top: 2em;
      display: grid;
      box-sizing: border-box;
    }
  }

  h1 {
    font-family: @FFami1;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 35px;
    /* or 109% */
    text-align: left;
    /* Black/500 */

    color: #262B33;

    margin: 0;
  }

  .my-form {
    margin-top: 25px;
  }
}

.success-modal-inner {
  padding: 85px 50px;

  .close {
    position: absolute;
    right: 30px;
    top: 30px;
  }

  .success-logo {
    background: #D5F3A7;
    .border-radius(50%);
    width: 84px;
    height: 84px;
    display: grid;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  h1 {
    font-family: @FFami1;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 125%;
    /* or 32px */

    text-align: center;

    color: #333333;
    margin: 30px 0 30px 0 ;
  }

  .success-text {
    font-family: @FFami1;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 125%;
    /* or 22px */

    text-align: center;

    color: #333333;
  }

  .buttons {
    align-items: center;
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }

}
.loading-wrapper {
  padding-top: 4rem;
}
</style>

<i18n>
{
  "en": {
    "title": "Rate the work of the Capitalist support team",
    "Ваш логин": "Your username",
    "Причина": "Reason",
    "Контактные данные": "Contacts",
    "Где происходило общение": "Where did you have a conversation",
    "Расскажите подробнее, что вам не понравилось": "Tell us in more detail what you didn’t like",
    "Логин или email": "Username or email",
    "Контактные данные, с которых вы обращались": "The contact information from which you contacted",
    "Выберите мессенджер": "Select a messenger",
    "Опишите вашу проблему": "Describe your problem",
    "ЛК Capitalist": "Capitalist PM",
    "Отправить": "Send",
    "Ведущий специалист службы поддержки": "Lead Support specialist",
    "Cпециалист службы поддержки": "Support specialist",
    "success": {
      "title": "Thank you for your time",
      "text": "Your opinion will definitely be heard",
      "text_positive": "Your opinion will be heard and we will praise the employee",
      "closelabel": "Close window and go back to site"
    },
    "Специалист службы поддержки клиентов": "IT Support Specialist",
    "Загрузка данных...": "Loading data...",
    "Отправляется...": "Sending..."
  },
  "ru": {
    "title": "Оцените работу сотрудника поддержки Capitalist",
    "success": {
      "title": "Спасибо за уделенное время",
      "text": "Ваше мнение обязательно будет услышано",
      "text_positive": "Ваше мнение будет услышано и мы отблагодарим сотрудника",
      "closelabel": "Закрыть и перейти на главную"
    }
  }
}
</i18n>
